import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Phone, Mail, MapPin, Clock, ArrowUp } from "lucide-react";
import { site, navFlat, gallery } from "../data/mock";
import Img from "./Img";

export default function Footer() {
  return (
    <footer className="bg-[#252b27] text-white/70">
      <div className="mx-auto grid max-w-[1200px] gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Img
            src={site.logo}
            alt="Logo Ann Home - Eat clean & Healthy food"
            width={320}
            height={320}
            className="mb-5 h-16 w-auto rounded-sm"
          />
          <p className="ah-body !text-[14px] !text-white/60">
            Căn bếp handmade tại TP.HCM: bữa ăn eat clean, bánh Trung thu Mộc
            Hương Thu Nguyệt, bánh kem Min's Bake Studio và lớp dạy làm bánh.
          </p>
          <a
            href={site.facebook}
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook Ann Home"
            className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-all duration-300 hover:border-[#8fa243] hover:bg-[#8fa243] hover:text-white"
          >
            <Facebook size={16} />
          </a>
        </div>

        <div>
          <h2 className="mb-6 text-[12px] font-bold uppercase tracking-[0.2em] text-white">
            Liên kết
          </h2>
          <ul className="space-y-3">
            {navFlat.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  className="text-[14px] font-light transition-colors duration-300 hover:text-[#a9bd58]"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="mb-6 text-[12px] font-bold uppercase tracking-[0.2em] text-white">
            Liên hệ
          </h2>
          <ul className="space-y-4 text-[14px] font-light">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-1 shrink-0 text-[#a9bd58]" />
              <span>{site.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-1 shrink-0 text-[#a9bd58]" />
              <a href={site.phoneHref} className="transition-colors hover:text-[#a9bd58]">
                {site.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-1 shrink-0 text-[#a9bd58]" />
              <span
                className="break-all"
                dangerouslySetInnerHTML={{
                  __html: `<!--email_off--><a href="mailto:${site.email}" class="transition-colors hover:text-[#a9bd58]">${site.email}</a><!--/email_off-->`,
                }}
              />
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="mt-1 shrink-0 text-[#a9bd58]" />
              <span>{site.hours}</span>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="mb-6 text-[12px] font-bold uppercase tracking-[0.2em] text-white">
            Instagram
          </h2>
          <div className="grid grid-cols-2 gap-2">
            {gallery.map((g) => (
              <div key={g.src} className="ah-card overflow-hidden">
                <Img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="ah-card-img h-[86px] w-full object-cover opacity-80 hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-4 px-6 py-6 text-[12px] tracking-wider text-white/60 sm:flex-row">
          <p>© Annhome - Eat clean &amp; Healthy food</p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 uppercase tracking-[0.18em] transition-colors duration-300 hover:text-[#a9bd58]"
          >
            Lên đầu trang <ArrowUp size={13} />
          </button>
        </div>
      </div>
    </footer>
  );
}
